import {
  FamilyParentProfile,
  JoonUIColor,
  Loader,
  TextButton,
  Typography,
} from "@joonapp/web-shared"

import { useQuestionnaireQuery } from "../../../networking/questionnaires/queries"
import { QuestionnaireAnswersResponse } from "../../../types"
import useSurveysModalStore from "../store/useSurveysModalStore"

const ParentSurveySectionItem = ({
  parentProfile,
}: {
  parentProfile: FamilyParentProfile
}) => {
  const { data: parentSurveys, isLoading } = useQuestionnaireQuery(
    parentProfile.user.id
  )

  return (
    <div className="justify-between border border-borderPrimary rounded-md">
      <div className="p-3 flex flex-row gap-2 items-center justify-between min-h-12">
        <Typography variant="body">
          {parentProfile.user.name}
          {parentProfile.nickname && ` (${parentProfile.nickname})`}
        </Typography>
        {isLoading && (
          <Loader thickness={2} color={JoonUIColor.icon.light} size={16} />
        )}
      </div>
      {parentSurveys &&
        parentSurveys.map((survey) => (
          <SurveyItem profile={parentProfile} survey={survey} />
        ))}
    </div>
  )
}

export default ParentSurveySectionItem

const SurveyItem = ({
  profile,
  survey,
}: {
  profile: FamilyParentProfile
  survey: QuestionnaireAnswersResponse
}) => {
  const { selectSurvey } = useSurveysModalStore()

  const handleSelectSurvey = () => {
    selectSurvey({
      survey,
      profile,
    })
  }

  return (
    <div className="flex flex-row gap-2 justify-between items-center border-t border-borderPrimary px-3 py-1 min-h-12">
      <Typography variant="bodySmall">
        {survey.questionnaire.display_name}
      </Typography>
      <TextButton onClick={handleSelectSurvey}>
        <Typography variant="bodySmall" color={JoonUIColor.text.primaryAccent}>
          View
        </Typography>
      </TextButton>
    </div>
  )
}
